import QuizAttemptsChart from "./QuizAttemptsChart";

export default QuizAttemptsChart